import React from "react";
import { Navigate } from "react-router-dom";

import { Restricted } from "lib/auth";

export const LandingPage: React.FC = () => {
  return (
    <>
      <Restricted permits={["view_user"]}>
        <Navigate to="/users" />
      </Restricted>
      <Restricted permits={["view_patient"]}>
        <Navigate to="/patients" />
      </Restricted>
    </>
  );
};
